import Vue from "vue";

Vue.filter("propertyBulletpoints", function(itemData)
{
    if (!itemData || !itemData.variationProperties || itemData.variationProperties.length === 0)
    {
        return [];
    }

    const bulletpoints = [];

    for (const property of itemData.variationProperties)
    {
        if (property.property.id in [178, 179, 180, 181, 182, 218])
        {
            bulletpoints.push(property.values.value);
        }
    }

    return bulletpoints;
});
